export default __webpack_public_path__ + "static/media/bg3.908bea92.jpg";